module.exports = __webpack_public_path__ + "img/happy.5502c1b9.png";